import { render, staticRenderFns } from "./AssetsInfoModal.vue?vue&type=template&id=c46c5ae0&scoped=true"
import script from "./AssetsInfoModal.vue?vue&type=script&lang=js"
export * from "./AssetsInfoModal.vue?vue&type=script&lang=js"
import style0 from "./AssetsInfoModal.vue?vue&type=style&index=0&id=c46c5ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46c5ae0",
  null
  
)

export default component.exports